module.exports = __webpack_public_path__ + "img/leader-2.085cce3c.png";